/**
 * AIOE-first (workbench D301 asked to mirror it): what a project route answers when it refuses the
 * caller, and what `GET /projects/v1/:id` always carries, so a workbench or node reads both with a
 * schema instead of by hand.
 *
 * A refusal (`refusalBody` in the API's boards/caller.ts) is `{ error, message?, mergedInto?,
 * principal?, principalName? }`:
 *   - `not_found` (404): the project does not exist, or the caller is not on it.
 *   - `not_a_member` (403): a node or a relaying desktop named a person who is not a member;
 *     `principal` is that person's id and `principalName` their name, when the organisation knows it.
 *   - `no_person` (403): a node wrote without naming the member it works for.
 *   - `merged` (409 on project routes, 410 on `GET /projects/v1/:id`): `mergedInto` is the project it became.
 *   - `archived` (409): the project is read-only until an owner restores it.
 *
 * A project read answers the project, the caller's `role` there, and its members with their roles. A
 * node reads as a `viewer`, or for the member it names in x-aioe-principal with at most a contributor's
 * rights (`role`); `memberRole` is then that member's own role, through a team included. Other fields
 * (roots, compute, policy, area, promotion, requests) are present as the project has them.
 */
import { z } from "zod";
import { projectMemberSchema, projectRoleSchema, projectSchema } from "./projects.js";
export const callerRefusalSchema = z.object({
    error: z.string(),
    message: z.string().optional(),
    mergedInto: z.string().optional(),
    principal: z.string().optional(),
    principalName: z.string().optional(),
});
export const projectReadSchema = z.looseObject({
    project: projectSchema.loose(),
    role: projectRoleSchema,
    memberRole: projectRoleSchema.optional(),
    members: z.array(projectMemberSchema.loose()),
});
//# sourceMappingURL=callerRefusal.js.map